import { graphql } from 'react-relay/legacy';
import RequestShippingQuoteModal from '../ShippingRequestModal/RequestShippingQuoteModal'; // eslint-disable-line no-unused-vars

export default graphql`
    query ShippingRequestModalQuery(
        $userId: String!
        $userIds: [String]
        $hasUserId: Boolean!
        $itemId: String!
        $shouldFetchItem: Boolean = false
        $itemIds: [String]
        $shouldFetchConversation: Boolean = true
        $shouldFetchTransaction: Boolean = false
        $zipCode: String = ""
        $country: String = ""
        $canCheckZipCode: Boolean = false
        $conversationId: ID = 0
        $hasConversationId: Boolean = false
        $shouldFetchItemDelivery: Boolean = false
        $addressResolutionType: AddressResolutionType = IP
        $shouldFetchTransactionDelivery: Boolean = false
        $transactionId: String = ""
        $itemQuantity: Int
    ) {
        viewer {
            ...RequestShippingQuoteModal_viewer
        }
    }
`;
